/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material';

import { CIColors } from 'shared';

type MuiSliderComponent = {
  defaultProps?: ComponentsProps['MuiSlider'];
  styleOverrides?: ComponentsOverrides['MuiSlider'];
  variants?: ComponentsVariants['MuiSlider'];
};

export const SliderComponent: MuiSliderComponent = {
  styleOverrides: {
    root: {
      width: 'calc(100% - 26px)',
      color: '#F6F7F8',
      height: 8,
      marginLeft: 12,
      marginRight: 14,
      '&::before': {
        display: 'flex',
        position: 'absolute',
        left: -12,
        content: '""',
        width: 12,
        height: 12,
        backgroundColor: '#F6F7F8',
        borderTopLeftRadius: '2px',
        borderBottomLeftRadius: '2px',
      },
      '&::after': {
        display: 'flex',
        position: 'absolute',
        right: -14,
        content: '""',
        width: 14,
        height: 12,
        backgroundColor: '#F6F7F8',
        borderTopRightRadius: '2px',
        borderBottomRightRadius: '2px',
      },
      '&.Mui-disabled': {
        color: '#F6F7F8 !important',
        marginTop: '0 !important',
      },
    },
    thumb: {
      height: 20,
      width: 20,
      color: CIColors.Primary,
      backgroundColor: '#fff',
      border: '3.75px solid currentColor',
      zIndex: 3,
      '&:hover': {
        boxShadow: 'inherit',
      },
      '&.Mui-active': {
        boxShadow: 'inherit',
      },
    },
    active: {},
    valueLabel: {
      display: 'block',
      left: 'calc(-50% - 4px)',
    },
    track: {
      height: 12,
      zIndex: 2,
    },
    rail: {
      height: 12,
      width: '100%',
      borderRadius: 0,
      opacity: 1,
      transform: 'translateY(-4px)',
    },
    mark: {
      marginTop: '2px',
      color: CIColors.Text,
      zIndex: 1,
      opacity: '0.4',
    },
    markActive: {},
    markLabel: {
      color: CIColors.Text,
      marginLeft: '1px',
      fontSize: '14px',
      letterSpacing: '-0.09px',
    },
    markLabelActive: {
      color: CIColors.Primary,
    },
  },
};
